import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SPACING } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const MainContainer = styled(Grid)({
  width: "100vw",
  height: "100vh",
  maxWidth: "100vw",
  maxHeight: "100vh",
  overflow: "hidden",
});

export const Container = styled(Grid)((theme) => ({
  width: "100%",
  height: `calc(100% - ${SPACING[9]}px)`,
  display: "flex",
  padding: `
    ${SPACING[9]}px 
    ${SPACING[9]}px
    0px
    ${SPACING[9]}px
  `,
}));

export const HeaderAndContentContainer = styled(Grid)({
  maxWidth: "100%",
  overflow: "hidden",
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  paddingLeft: `${SPACING[3]}px`, //10
});

export const HeaderContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  height: "70px",
  marginBottom: `${SPACING[7]}px`,
}));

export const ContentContainer = styled(Grid)({
  height: "calc(100% - 100px)",
  width: "100%",
  overflow: "auto",
});

export const Content = styled(Grid)({
  transition: "all .6s ease",
  backgroundColor: "white",
});

export const TitleContainer = styled(Grid)(({ theme }) => ({
  borderRadius: "12px",
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  gap: "10px",
  padding: "10px",
  alignItems: "center",
}));

export const Title = styled(Typography)({
  display: "WebkitBox",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  lineHeight: "1",
});

export const StatusAmountContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
});

export const StatusAmountBlock = styled(Grid)({
  width: "fit-content",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "5px",
});
